import { __exports as n } from "./index175.js";
import "./index186.js";
import "./index187.js";
import { __exports as d } from "./index188.js";
import { __exports as m } from "./index189.js";
Object.defineProperty(n, "__esModule", { value: !0 });
n.default = E;
var i = d, u = m, _ = ["checked", "value"], v = ["input", "select", "textarea"], y = {
  reset: !0,
  submit: !0
};
function E(e, f) {
  e === void 0 && (e = {});
  var t = {}, l = !!(e.type && y[e.type]);
  for (var a in e) {
    var o = e[a];
    if ((0, i.isCustomAttribute)(a)) {
      t[a] = o;
      continue;
    }
    var s = a.toLowerCase(), r = c(s);
    if (r) {
      var p = (0, i.getPropertyInfo)(r);
      switch (_.includes(r) && v.includes(f) && !l && (r = c("default" + s)), t[r] = o, p && p.type) {
        case i.BOOLEAN:
          t[r] = !0;
          break;
        case i.OVERLOADED_BOOLEAN:
          o === "" && (t[r] = !0);
          break;
      }
      continue;
    }
    u.PRESERVE_CUSTOM_ATTRIBUTES && (t[a] = o);
  }
  return (0, u.setStyleProp)(e.style, t), t;
}
function c(e) {
  return i.possibleStandardNames[e];
}
